var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilterSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5552 18.2754C14.5552 18.86 14.1718 19.6266 13.683 19.9237L12.3318 20.7958C11.0764 21.572 9.33224 20.7 9.33224 19.1475V14.0204C9.33224 13.34 8.94891 12.4679 8.55599 11.9887L4.87596 8.11703C4.38721 7.62828 4.00391 6.76579 4.00391 6.18121V3.95787C4.00391 2.79829 4.87601 1.92621 5.93976 1.92621H18.7239C19.7876 1.92621 20.6597 2.79828 20.6597 3.86203V5.98953C20.6597 6.76578 20.171 7.73371 19.6918 8.21287",
    stroke: "#002A58",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2327 15.8318C17.9264 15.8318 19.2994 14.4588 19.2994 12.7651C19.2994 11.0714 17.9264 9.69843 16.2327 9.69843C14.539 9.69843 13.166 11.0714 13.166 12.7651C13.166 14.4588 14.539 15.8318 16.2327 15.8318Z",
    stroke: "#002A58",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8743 16.4068L18.916 15.4484",
    stroke: "#002A58",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterSearch);
export default __webpack_public_path__ + "static/media/filter-search.d79a4e0cc4fc04e90844556a04475c67.svg";
export { ForwardRef as ReactComponent };